import React from 'react';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { BillingPanel } from './BillingPanel';
import { SITE_NAME } from '../../constants';

export const SettingsGeneral: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white">Configurações Gerais</h1>
        <p className="text-neutral-400 mt-1">Gerencie sua conta {SITE_NAME}</p>
      </div>

      {/* Profile Section */}
      <div className="liquid-glass rounded-2xl p-6 mb-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-white">Perfil</h2>
          <Link
            to="/dashboard/profile"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors"
          >
            Editar perfil
          </Link>
        </div>
        <div className="flex items-center gap-4">
          {user?.avatar_url ? (
            <img src={user.avatar_url} alt="" className="w-12 h-12 rounded-full object-cover" />
          ) : (
            <div className="w-12 h-12 rounded-full bg-primary-500/20 flex items-center justify-center">
              <User className="w-6 h-6 text-primary-400" />
            </div>
          )}
          <div>
            <p className="text-white font-medium">{user?.full_name || 'Usuário'}</p>
            <p className="text-neutral-400 text-sm">{user?.username ? `@${user.username}` : user?.email}</p>
          </div>
        </div>
      </div>

      {/* Billing Section */}
      <BillingPanel />
    </div>
  );
};
